"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InnerReactSelect = void 0;
Object.defineProperty(exports, "components", {
  enumerable: true,
  get: function get() {
    return _reactSelect.components;
  }
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactSelect = _interopRequireWildcard(require("react-select"));
var _reduxForm = require("redux-form");
var _cssClassesHelper = require("../../../helpers/cssClassesHelper");
require("./APReactSelect.css");
var _classnames = _interopRequireDefault(require("classnames"));
var _excluded = ["input", "label", "meta", "info", "options", "customClass", "disabled", "onSelect", "valueAsObject", "classModifiers", "placeholder", "formatOptionLabel"],
  _excluded2 = ["input", "label", "meta", "info", "options", "customClass", "disabled", "onSelect", "valueAsObject", "classModifiers", "components"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
// Detect if device is mobile (iOS or Android)
var isMobileDevice = function isMobileDevice() {
  if (typeof window === 'undefined') return false;
  return /iPhone|iPad|iPod|Android/i.test(navigator.userAgent) || window.innerWidth <= 768;
};
var customStyles = {
  menu: function menu(base) {
    return _objectSpread(_objectSpread({}, base), {}, {
      background: "rgb(var(--pc__background-secondary))",
      position: 'absolute'
    });
  },
  menuPortal: function menuPortal(base) {
    return _objectSpread(_objectSpread({}, base), {}, {
      zIndex: 10000
    });
  },
  control: function control(base, state) {
    return _objectSpread(_objectSpread({}, base), {}, {
      fontSize: 'var(--input__font-size)',
      minHeight: 'auto',
      height: 'var(--input__height)',
      padding: '0 2.5rem 0 1rem',
      borderRadius: '2px',
      flexShrink: 0,
      color: 'var(--input__color)',
      borderWidth: '1px',
      borderStyle: 'solid',
      borderColor: state.menuIsOpen ? 'var(--input__border-color--hover)' : 'var(--input__border-color)',
      background: state.menuIsOpen ? 'var(--input__bg-color--focus);' : 'var(--input__bg-color)',
      boxShadow: 'none',
      '&:hover': {
        borderColor: 'var(--input__border-color--hover)'
      }
    });
  },
  container: function container(base) {
    return _objectSpread(_objectSpread({}, base), {}, {
      padding: 0
    });
  },
  option: function option(base, _ref) {
    var isDisabled = _ref.isDisabled,
      isFocused = _ref.isFocused;
    return _objectSpread(_objectSpread({}, base), {}, {
      paddingLeft: '1.2rem',
      borderBottom: '1px solid #1F232E',
      backgroundColor: isDisabled ? "transparent" : isFocused ? 'rgb(var(--pc__background-tertiary))' : "rgb(var(--pc__background-secondary))",
      color: isDisabled ? '#888' : 'inherit',
      // Faint text for disabled options
      opacity: isDisabled ? 0.5 : 1,
      // Fade disabled options
      pointerEvents: isDisabled ? 'none' : 'auto' // Prevent selection
    });
  },
  input: function input(base) {
    return _objectSpread(_objectSpread({}, base), {}, {
      color: 'white'
    });
  },
  placeholder: function placeholder(base) {
    return _objectSpread(_objectSpread({}, base), {}, {
      color: 'white'
    });
  },
  noOptionsMessage: function noOptionsMessage(base) {
    return _objectSpread(_objectSpread({}, base), {}, {
      color: 'white'
    });
  },
  singleValue: function singleValue(provided) {
    return _objectSpread(_objectSpread({}, provided), {}, {
      color: 'var(--input__color)',
      padding: '0.4rem 0px'
    });
  },
  valueContainer: function valueContainer(base) {
    return _objectSpread(_objectSpread({}, base), {}, {
      padding: 0
    });
  },
  indicatorsContainer: function indicatorsContainer(base) {
    return _objectSpread({}, base);
  },
  menuList: function menuList(base) {
    return _objectSpread(_objectSpread({}, base), {}, {
      paddingTop: 0,
      paddingBottom: 0
    });
  }
};

// Native select component for mobile devices
var NativeSelect = function NativeSelect(props) {
  var _input$value;
  var input = props.input,
    label = props.label,
    meta = props.meta,
    info = props.info,
    options = props.options,
    customClass = props.customClass,
    disabled = props.disabled,
    onSelect = props.onSelect,
    _props$valueAsObject = props.valueAsObject,
    valueAsObject = _props$valueAsObject === void 0 ? true : _props$valueAsObject,
    classModifiers = props.classModifiers,
    placeholder = props.placeholder,
    formatOptionLabel = props.formatOptionLabel,
    passedProps = _objectWithoutProperties(props, _excluded);
  var baseClasses = (0, _cssClassesHelper.getBEMClasses)(['react-select', customClass]);
  var handleChange = function handleChange(e) {
    var selectedValue = e.target.value;
    if (!selectedValue) {
      if (onSelect) onSelect(null);
      input && input.onChange(null);
      return;
    }
    var selectedOption = options.find(function (opt) {
      return String(opt.value) === selectedValue;
    });
    if (onSelect) onSelect(selectedOption);
    input && input.onChange(valueAsObject ? selectedOption : selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.value);
  };
  var currentValue = valueAsObject ? (_input$value = input.value) === null || _input$value === void 0 ? void 0 : _input$value.value : input.value;
  var getOptionLabel = function getOptionLabel(option) {
    if (formatOptionLabel && typeof formatOptionLabel === 'function') {
      return formatOptionLabel(option);
    }
    return option.label;
  };
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "form-group ".concat(baseClasses('select-wrapper', classModifiers), " ").concat(baseClasses('native-wrapper'))
  }, !!label && /*#__PURE__*/_react["default"].createElement("label", {
    className: "ap--label ".concat(baseClasses('select-label'))
  }, label), /*#__PURE__*/_react["default"].createElement("select", {
    name: input === null || input === void 0 ? void 0 : input.name,
    value: currentValue || '',
    onChange: handleChange,
    onBlur: function onBlur() {
      return input && input.onBlur(input.value);
    },
    disabled: disabled,
    className: "form-control ".concat(baseClasses('select'), " ").concat(baseClasses('native-select'))
  }, placeholder && /*#__PURE__*/_react["default"].createElement("option", {
    value: "",
    disabled: true
  }, placeholder), options.map(function (option) {
    return /*#__PURE__*/_react["default"].createElement("option", {
      key: option.value,
      value: option.value,
      disabled: passedProps.isOptionDisabled && passedProps.isOptionDisabled(option)
    }, getOptionLabel(option));
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: baseClasses('triangle')
  }), /*#__PURE__*/_react["default"].createElement("small", {
    className: "form-text-muted ".concat(baseClasses('select-info'))
  }, info), meta && meta.dirty && meta.error && /*#__PURE__*/_react["default"].createElement("span", {
    className: baseClasses('select-error')
  }, meta.error));
};
var InnerReactSelect = exports.InnerReactSelect = function InnerReactSelect(props) {
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    isMobile = _useState2[0],
    setIsMobile = _useState2[1];
  (0, _react.useEffect)(function () {
    setIsMobile(isMobileDevice());
    var handleResize = function handleResize() {
      setIsMobile(isMobileDevice());
    };
    window.addEventListener('resize', handleResize);
    return function () {
      return window.removeEventListener('resize', handleResize);
    };
  }, []);

  // Use native select on mobile devices
  if (isMobile) {
    return /*#__PURE__*/_react["default"].createElement(NativeSelect, props);
  }
  var input = props.input,
    label = props.label,
    meta = props.meta,
    info = props.info,
    options = props.options,
    customClass = props.customClass,
    disabled = props.disabled,
    onSelect = props.onSelect,
    _props$valueAsObject2 = props.valueAsObject,
    valueAsObject = _props$valueAsObject2 === void 0 ? true : _props$valueAsObject2,
    classModifiers = props.classModifiers,
    providedComponents = props.components,
    passedProps = _objectWithoutProperties(props, _excluded2);
  var baseClasses = (0, _cssClassesHelper.getBEMClasses)(['react-select', customClass]);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "form-group ".concat(baseClasses('select-wrapper', classModifiers))
  }, !!label && /*#__PURE__*/_react["default"].createElement("label", {
    className: "ap--label ".concat(baseClasses('select-label'))
  }, label), /*#__PURE__*/_react["default"].createElement(_reactSelect["default"], _extends({}, input, {
    value: valueAsObject ? input.value : options.find(function (option) {
      return option.value === input.value;
    })
  }, passedProps, {
    className: "form-control ".concat(baseClasses('select')),
    options: options,
    isOptionDisabled: passedProps.isOptionDisabled,
    onChange: function onChange(e) {
      if (onSelect) onSelect(e);
      input && input.onChange(valueAsObject ? e : e ? e.value : '');
    },
    onBlur: function onBlur() {
      input && input.onBlur(input.value);
    },
    menuPortalTarget: document.body,
    styles: customStyles,
    isDisabled: disabled,
    components: _objectSpread({
      IndicatorSeparator: function IndicatorSeparator() {
        return null;
      },
      IndicatorsContainer: function IndicatorsContainer(_ref2) {
        var selectProps = _ref2.selectProps,
          clearValue = _ref2.clearValue;
        return /*#__PURE__*/_react["default"].createElement("div", {
          className: baseClasses('indicators-container')
        }, selectProps.isClearable && selectProps.value && /*#__PURE__*/_react["default"].createElement("div", {
          className: baseClasses('clear-indicator'),
          onMouseDown: function onMouseDown(e) {
            e.stopPropagation();
            e.preventDefault();
            clearValue();
          }
        }, "\xD7"), /*#__PURE__*/_react["default"].createElement("div", {
          className: baseClasses('triangle', {
            opened: selectProps.menuIsOpen
          })
        }));
      },
      Control: function Control(props) {
        return /*#__PURE__*/_react["default"].createElement(_reactSelect.components.Control, _extends({}, props, {
          className: (0, _classnames["default"])(baseClasses('select-control'), disabled ? 'disabled' : '')
        }));
      },
      Placeholder: function Placeholder(props) {
        return /*#__PURE__*/_react["default"].createElement(_reactSelect.components.Placeholder, _extends({}, props, {
          className: baseClasses('select-placeholder')
        }));
      },
      SingleValue: function SingleValue(props) {
        return /*#__PURE__*/_react["default"].createElement(_reactSelect.components.SingleValue, _extends({}, props, {
          className: baseClasses('select-single-value')
        }));
      }
    }, providedComponents)
  })), /*#__PURE__*/_react["default"].createElement("small", {
    className: "form-text-muted ".concat(baseClasses('select-info'))
  }, info), meta && meta.dirty && meta.error && /*#__PURE__*/_react["default"].createElement("span", {
    className: baseClasses('select-error')
  }, meta.error));
};
var APSelect = function APSelect(props) {
  return /*#__PURE__*/_react["default"].createElement(_reduxForm.Field, _extends({
    name: props.name,
    component: InnerReactSelect
  }, props));
};
APSelect.defaultProps = {
  name: '',
  label: '',
  classes: 'input',
  customClass: 'custom-react-select',
  classModifiers: '',
  info: '',
  disabled: false,
  multiple: false,
  required: false,
  options: []
};
APSelect.propTypes = {
  name: _propTypes["default"].string.isRequired,
  label: _propTypes["default"].string,
  classes: _propTypes["default"].string,
  customClass: _propTypes["default"].string,
  classModifiers: _propTypes["default"].string,
  info: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].node]),
  onSelect: _propTypes["default"].func,
  disabled: _propTypes["default"].bool,
  multiple: _propTypes["default"].bool,
  required: _propTypes["default"].bool,
  options: _propTypes["default"].array.isRequired,
  components: _propTypes["default"].shape({})
};
var _default = exports["default"] = APSelect;